/**
 * Minimal helpers the print view needs to order a week's days Mon → Fri.
 * Dates are `DD.MM.YYYY` strings (e.g. "13.07.2026") — the same shape used in
 * the week JSON. Extracted from the original `dailyMenuWeeks.js`; only these two
 * functions are required for printing.
 */

/**
 * Parse `DD.MM.YYYY` into a local timestamp (ms), or 0 if unparsable.
 * @param {string} dateStr
 * @returns {number}
 */
export function parseDailyMenuDayDate(dateStr) {
  if (typeof dateStr !== 'string') {
    return 0;
  }
  const m = dateStr.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!m) {
    return 0;
  }
  const day = Number(m[1]);
  const month = Number(m[2]) - 1;
  const year = Number(m[3]);
  const d = new Date(year, month, day);
  if (d.getFullYear() !== year || d.getMonth() !== month || d.getDate() !== day) {
    return 0;
  }
  return d.getTime();
}

/**
 * Order days chronologically within the week using each day's `date`.
 * @param {Array<{ date?: string }>} days
 * @returns {Array<{ date?: string }>}
 */
export function sortWeekDaysByDateAsc(days) {
  if (!Array.isArray(days) || days.length === 0) {
    return [];
  }
  return [...days].sort((a, b) => {
    const ta = parseDailyMenuDayDate(a?.date ?? '');
    const tb = parseDailyMenuDayDate(b?.date ?? '');
    if (ta !== tb) {
      return ta - tb;
    }
    return 0;
  });
}
